import { Box, Container } from '@mui/material';
import React, { Component } from 'react';
import { JobReport } from '../../JobReport';
import { JobProcessingBanner } from '../JobProcessingBanner';
import PageHeader from '../../common/PageHeader';
import { AdminPageDetails, PageDetails } from '../config';

class AutoAssignmentReport extends Component {
  state = {
    id: 'autoAssignmentReport',
    title: '',
  };

  componentDidMount() {
    this.loadPageTitle();
  }

  //θ(N) where N is the number of pages in PageDetails
  //Retrieve page title from pageDetails using pageid
  loadPageTitle = () => {
    const page = Object.values(AdminPageDetails).find((page) => page.id === this.state.id);
    this.setState({
      title: page.title,
    });
  };

  render() {
    const id = this.state.id;
    return (
      <React.Fragment>
        <div id={`${id}__div_pageWrapper`} className={`myOdu__${id}`} style={{}}>
          <Container id={`${id}__container_pageWrapper`} className="myOdu__container secondaryPage">
            <PageHeader
              id={this.state.id}
              title={this.state.title}
              isSubPage
              pageConfig={{ ...PageDetails, ...AdminPageDetails }}
            />
            <JobProcessingBanner />

            <Box id={`${id}__box_wrapper`}>
              <JobReport id={this.state.id} widgetName="No Assignment Jobs Report" />
            </Box>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default AutoAssignmentReport;
